var __jsx = React.createElement;
import React from "react";
import Modal from "../../common/Modal";
import Button from "../../common/Button";
import { useTranslation } from "react-i18next";
var UnsavedChangesModal = function UnsavedChangesModal(_ref) {
  var show = _ref.show,
    title = _ref.title,
    message = _ref.message,
    confirmLabel = _ref.confirmLabel,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel,
    _ref$closeOnClickAway = _ref.closeOnClickAway,
    closeOnClickAway = _ref$closeOnClickAway === void 0 ? false : _ref$closeOnClickAway;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Modal, {
    show: show,
    title: title,
    className: "w-full sm:w-5/12 lg:w-4/12",
    closeOnClickAway: closeOnClickAway
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-6"
  }, message), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center p-4 w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center w-full sm:w-3/4 gap-4"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "grow w-full sm:w-auto",
    onClick: onConfirm
  }, confirmLabel), /*#__PURE__*/React.createElement(Button, {
    isPrimary: true,
    className: "mt-0 grow w-full sm:w-auto",
    onClick: onCancel
  }, t("button.cancel")))));
};
export default UnsavedChangesModal;